class LTACustomSection extends HTMLElement {
  constructor() {
    super();

    this.summaryHeaderMenuDrawer = document.getElementById('Details-menu-drawer-container')
    this.headerDrawerMenuCloseBtn = document.getElementById('HeaderMenuDrawerClose')


    console.log(this.summaryHeaderMenuDrawer);
    console.log(this.headerDrawerMenuCloseBtn);

    if (!this.summaryHeaderMenuDrawer || !this.headerDrawerMenuCloseBtn) return

    this.headerDrawerMenuCloseBtn.addEventListener('click', () => {
      this.summaryHeaderMenuDrawer.removeAttribute('open')

      this.summaryHeaderMenuDrawer.querySelector('summary').setAttribute('aria-expanded', 'false')
    })
  }
}

customElements.define('lta-custom-section', LTACustomSection);
